/**
 * Label Helper Utility
 * Centralized label access with fallbacks
 */

import { useTenant } from '../context/TenantContext';

export const useLabels = () => {
  // Call hook unconditionally (hooks must be called in the same order every render)
  const { tenant } = useTenant();
  
  const getLabel = (key, fallback = key) => {
    if (!tenant || !tenant.labels) return fallback;
    return tenant.labels[key] || fallback;
  };
  
  return {
    customer: getLabel('customer', 'Customer'),
    customers: getLabel('customers', 'Customers'),
    staff: getLabel('staff', 'Staff'),
    staff_plural: getLabel('staff_plural', 'Staff'),
    appointment: getLabel('appointment', 'Appointment'),
    appointments: getLabel('appointments', 'Appointments'),
    service: getLabel('service', 'Service'),
    services: getLabel('services', 'Services'),
    visit: getLabel('visit', 'Visit'),
    prescription: getLabel('prescription', 'Prescription'),
    // Add more labels as needed
  };
};

/**
 * Get label without hook (for use outside components)
 */
export const getLabelFromTenant = (tenant, key, fallback = key) => {
  if (!tenant) return fallback;
  return tenant.labels?.[key] || fallback;
};

